<template>
  <b-modal
    id="modal-approve-regularization"
    ref="inner-modal"
    title="Approve Regularization Request"
    ok-title="Approve"
    cancel-title="Cancel"
    ok-variant="success"
    :ok-disabled="!localComment || !localComment.trim()"
    size="lg"
    @ok.prevent="handleOk"
    @hidden="handleHidden"
  >
    <b-form v-if="regularization">
      <b-alert variant="info" show class="mb-3">
        <div class="regularization-details">
          <div class="mb-2">
            <strong>Employee:</strong> {{ employeeName }}<br>
            <strong>Date:</strong> {{ formatDate(regularization.date || regularization.datestring) }}<br>
            <strong>Issue:</strong> {{ regularization.issue_type || 'Regularization' }}<br>
            <strong>Data Source:</strong> {{ regularization.data_source_status || regularization.data_source || 'N/A' }}<br>
            <strong>Leave Type:</strong> {{ regularization.leave_type || 'Not Selected' }}
          </div>

          <hr class="my-2">

          <b-alert
            v-if="timesNotRequired"
            variant="light"
            show
            class="mb-2 py-2"
          >
            <small class="text-muted">
              <feather-icon icon="InfoIcon" size="14" class="mr-1" />
              Time is not required for this leave type. Missing punch times will not block approval.
            </small>
          </b-alert>

          <div v-if="showTimeDetails" class="time-comparison">
            <h6 class="mb-2">Time Details:</h6>
            <div class="row">
              <div class="col-12 col-md-4 mb-2">
                <strong>Biometric Times:</strong><br>
                <small class="text-muted">
                  IN: {{ formatTime(regularization.bm_in_time) }}<br>
                  OUT: {{ formatTime(regularization.bm_out_time) }}
                </small>
              </div>
              <div class="col-12 col-md-4 mb-2">
                <strong>Punch Times:</strong><br>
                <small class="text-muted">
                  IN: {{ formatTime(regularization.punch_in_time) }}<br>
                  OUT: {{ formatTime(regularization.punch_out_time) }}
                </small>
              </div>
              <div class="col-12 col-md-4 mb-2">
                <strong>Submitted Times:</strong><br>
                <small class="text-muted">
                  IN: {{ formatTime(regularization.att_in_time) }}<br>
                  OUT: {{ formatTime(regularization.att_out_time) }}
                </small>
              </div>
            </div>
          </div>

          <hr v-if="regularization.remarks || regularization.comment" class="my-2">

          <div v-if="regularization.remarks || regularization.comment" class="mt-2">
            <strong>Employee Remarks:</strong><br>
            <small class="text-muted">{{ regularization.remarks || regularization.comment || 'N/A' }}</small>
          </div>

          <div v-if="regularization.manager_remarks || regularization.manager_comment" class="mt-2">
            <strong>Manager Remarks:</strong><br>
            <small class="text-muted">{{ regularization.manager_remarks || regularization.manager_comment || 'N/A' }}</small>
          </div>
        </div>
      </b-alert>

      <b-form-group label="Approval Comment" label-for="regularization-approval-comment">
        <b-form-textarea
          id="regularization-approval-comment"
          v-model="localComment"
          rows="4"
          placeholder="Please provide a comment (required)"
          required
          @input="$emit('update:comment', localComment)"
        />
        <small class="text-danger">Comment is mandatory for approval</small>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import moment from 'moment'
import {
  BModal, BForm, BFormGroup, BFormTextarea, BAlert,
} from 'bootstrap-vue'
import { requiresRegularizationTime } from '@/utils/attendance-leave-types'

export default {
  name: 'ApproveRegularizationModal',
  components: { BModal, BForm, BFormGroup, BFormTextarea, BAlert },
  props: {
    regularization: { type: Object, default: null },
    employeeName: { type: String, default: '' },
    comment: { type: String, default: '' },
  },
  data() {
    return { localComment: '' }
  },
  watch: {
    comment(val) { this.localComment = val },
  },
  computed: {
    resolvedLeaveType() {
      if (!this.regularization) return null
      return this.regularization.leave_type || null
    },
    timesNotRequired() {
      if (!this.regularization) return false
      const leaveType = this.resolvedLeaveType
      if (leaveType) return !requiresRegularizationTime(leaveType)
      const attendance = String(this.regularization.attendance || '').toLowerCase()
      return attendance === 'leave'
    },
    showTimeDetails() {
      return !this.timesNotRequired
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return 'N/A'
      return moment(date).format('DD MMM YYYY')
    },
    formatTime(time) {
      if (!time || time === '0:00:00' || time === '00:00:00') return 'N/A'
      return time
    },
    handleOk() {
      if (!this.localComment || !this.localComment.trim()) return
      this.$emit('confirm', this.localComment.trim())
    },
    handleHidden() {
      this.localComment = ''
      this.$emit('hidden')
    },
    show() { this.$refs['inner-modal'].show() },
    hide() { this.$refs['inner-modal'].hide() },
  },
}
</script>
